import { render } from "./tutorSidebar.vue?vue&type=template&id=40fbbc2c"
import script from "./tutorSidebar.vue?vue&type=script&lang=js"
export * from "./tutorSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__